export default __webpack_public_path__ + "static/media/exclusivity.757f08a9.svg";